

jQuery(document).ready(function($) {
  
  var my_front = 0;
  var my_back = 0;
  var sel = 0;
  var convert_b_text = 'convert2cm';
  var number_of_fit = 0;
  var phrases_or_names = 'phrases';
  var front_or_back;
  var front_back_2go;
  var winWidth = $('body').innerWidth();
  var winHeight = window.innerHeight;
  var ok2translate = 1;
  var translation1;
  var translation2;
  var ok2choose=1;
  var prev_skyline = 'none';
  var current_words_front;
  var current_words_back;
  var max_words_front;
  var max_words_back;
  var words;
  var selected1_number_of_words;
  var selected2_number_of_words;
  var my_front_back;
  var number_of_selected_that_fit;
  var phrase_was_chosen = 0;
  var original_price = $('.product-info>.uc-price').text();
  var bottom_price;
  var add2cart_clicked = 0;

  var front_heart = 0;
  var back_heart = 0;
  var front_tilde = 0;
  var back_tilde = 0;
  var front_flower = 0;
  var back_flower = 0;
  var front_sod = 0;
  var back_sod = 0;

  if (winWidth > winHeight) {
      //$('#phrases_block_wrapper').perfectScrollbar('destroy');
      //$('#phrases_block_wrapper').perfectScrollbar();

    //  $("#phrases_family_list .category-list").mCustomScrollbar("destroy");
     // $("#phrases_family_list .category-list").mCustomScrollbar();
  }
  $('#total_blocker').show();
fetchQuoteCategoryAll();
  // if attibute was changed
  //if (settings.url == '/system/ajax') {
  my_front = $('#current_words_front').text();
  my_back = $('#current_words_back').text();
/*
                  if ($('body').hasClass('front')) {
                    front_or_back = 'front';
                } else {
                    front_or_back = 'back';
                }

  my_front = $('#current_words_front').text();
				my_back = $('#current_words_back').text();

  if(front_or_back=='front'){
                	// if one phrase was chosen, update the relative number of phrases according to letter count
                	if($('.phrase_chosen1').css('display')=='block'){
						my_front_back = max_words_front - $('#myvars').attr('chosen1_letter_count');
					}else{
                    my_front_back = max_words_front - my_front;
					}
                }else{
					// if one phrase was chosen, update the relative number of phrases according to letter count
					if($('.phrase_chosen1').css('display')=='block'){
						my_front_back = max_words_back - $('#myvars').attr('chosen1_letter_count');
					}else{
						my_front_back = max_words_back-my_back;
					}
                }

    $('#myvars').attr(front_or_back + '2go',my_front_back);
  front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));

  $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
    if ($(this).text() <= front_back_2go) {
      number_of_fit++;
      $(this).parent().removeClass('inactive');
    } else {
      $(this).parent().addClass('inactive');
    }
  });
  console.log('number_of_fit: '+ number_of_fit);
  console.log('front_back_2go: '+front_back_2go);

  $('#filter_fit .filter_count').text(number_of_fit);
  $('#filter_all .filter_count').text($('#' + phrases_or_names + '_block_content .phrase_word_count').length);*/
  //$('#phrases_block_wrapper').scrollTop(0);

  
    max_words_front = $('#myvars').attr('max_words_front');
  max_words_back = $('#myvars').attr('max_words_back');
  
/*
  console.log('my_front: '+my_front);

  number_of_fit = 0;
  if(front_or_back=='front'){
    // if one phrase was chosen, update the relative number of phrases according to letter count
    if($('.phrase_chosen1').css('display')=='block'){
      my_front_back = max_words_front - $('#myvars').attr('chosen1_letter_count');
    }else{
      my_front_back = max_words_front - my_front;
    }
  }else{
    // if one phrase was chosen, update the relative number of phrases according to letter count
    if($('.phrase_chosen1').css('display')=='block'){
      my_front_back = max_words_back - $('#myvars').attr('chosen1_letter_count');
    }else{
      my_front_back = max_words_back-my_back;
    }
  }*/

  //console.log('number_of_fit: '+ number_of_fit);

  // fade in active letters
  $('#phrases_block_wrapper').fadeIn(400);

  // update number of phrases that fit
  /*$('#myvars').attr(front_or_back + '2go',my_front_back);
  front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));

  $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
    if ($(this).text() <= front_back_2go) {
      number_of_fit++;
      $(this).parent().removeClass('inactive');
    } else {
      $(this).parent().addClass('inactive');
    }
  });
  console.log('number_of_fit: '+ number_of_fit);

  $('#filter_fit .filter_count').text(number_of_fit);
  $('#filter_all .filter_count').text($('#' + phrases_or_names + '_block_content .phrase_word_count').length);
  //$('#phrases_block_wrapper').scrollTop(0);*/


  //console.log('front_back_2go: '+ front_back_2go);

  
  
  // get convert button text
  convert_b_text = $('#convert2cm').text();

  // get previous selected engraving value and substract it from number of words

  //sel = $('.attribute-10 select option:selected').val();
  if(sel==21){
    prev_skyline = 'front_only';
  }else if(sel==24){
    prev_skyline = 'back_only';
  }if(sel==25){
    prev_skyline = 'both_sides';
  }if(sel==20){
    prev_skyline = 'none';
  }

/// clicking on .phrases_filter
  //$('.phrases_filter').click(function(){
  $(document).on('click', '.phrases_filter', function () {
    $('.phrases_filter').removeClass('active');
    $(this).addClass('active');

    if ($(this).attr('id') == "filter_all") {
      $('body').addClass('show_all');
    } else {
      $('body').removeClass('show_all');
    }
  });
  
// set first psukim & phrases family as active
  //$('.phrase-family-b:nth-child(1)').addClass('active');
  if ($('#phrases_family h2').hasClass('active')) {
    $('body').addClass('phrase_block');
    // call scrollbar jquery
    if (winWidth > winHeight) {
      //$('#phrases_block_wrapper').perfectScrollbar('destroy');
      //$('#phrases_block_wrapper').perfectScrollbar();

      $("#phrases_block_wrapper").mCustomScrollbar("destroy");
      $("#phrases_block_wrapper").mCustomScrollbar({
        callbacks:{
          whileScrolling:function(){
            whilescroll();
          }
        }
      });
    }
  }

  ///// if on page load a skyline is selected, update number of letters in the textareas

  setTimeout(function () {
    // if skyline was added, add 5 words to counter
    sel = $('.attribute-10 select option:selected').val();
    //front only
    if (sel == '21') {
      $('#current_words_front').text(22);
      $('#myvars').attr('front2go',Number(max_words_front)-22);
    }else if(sel == '24') {
      $('#current_words_back').text(22);
      $('#myvars').attr('back2go',Number(max_words_back)-22);
    }else if(sel == '25') {
      $('#current_words_front').text(22);
      $('#current_words_back').text(22);
      $('#myvars').attr('front2go',Number(max_words_front)-22);
      $('#myvars').attr('back2go',Number(max_words_back)-22);
    }


    // hide back skyline if not enought letters
    if(Number(max_words_back - $('#current_words_back').text()<22)){
      $('.attribute-10 select option:nth-child(3),.attribute-10 select option:nth-child(4)').attr('disabled','disabled');
    }
    if(Number(max_words_front - $('#current_words_front').text()<22)){
      $('.attribute-10 select option:nth-child(2),.attribute-10 select option:nth-child(4)').attr('disabled','disabled');
    }

    // show red alert if needed
    //max_words_front = $('#myvars').attr('max_words_front');
    if (max_words_front < Number($('#current_words_front').text())) {
      $('.front_tbox .word_counter_wrapper').addClass('red_alert');
    }else{
      $('.front_tbox .word_counter_wrapper').removeClass('red_alert');
    }

    //max_words_back = $('#myvars').attr('max_words_back');
    if (max_words_back < Number($('#current_words_back').text())) {
      $('.back_tbox .word_counter_wrapper').addClass('red_alert');
    }else{
      $('.back_tbox .word_counter_wrapper').removeClass('red_alert');
    }



  }, 500);






  // show mythink on heart click
  /*$(document).on('click', '.add2wishlist', function () {
    $(this).addClass('mythinkclass');
  });*/

  // disable_phrase_click
  //$(document).on('mouseover', '.add2wishlist', function () {
   // ok2choose=0;
  //});
  // disable_phrase_click
  //$(document).on('mouseout', '.add2wishlist', function () {
  //  ok2choose=1;
  //});


  /// on scroll, active relevant phrase-family-b
  var my_index1;
  function whilescroll(){
    var winWidth = $('body').innerWidth();
    var winHeight = window.innerHeight;

    if(winWidth > 760){
      //console.log($('#mCSB_1_container').offset().top);

      $('.phrase_family_wrapper').each(function() {
        my_index1 = $('.phrase_family_wrapper').index($(this));
        if($('#mCSB_2.mCustomScrollBox').offset().top - $(this).offset().top>-15){
          $('.phrase-family-b').removeClass('active');
          $('.phrase-family-b:nth-child(' + Number(my_index1+1) + ')').addClass('active');
        }
      });
    }
  }
  
  function update_skyline() {
    if($('.attribute-10').length>0) {
      setTimeout(function () {
        // if skyline was added, add 22 words to counter
        sel = $('.attribute-10 select option:selected').val();
        //front only
        if (sel == '21') {
          if (prev_skyline == 'none') {
            $('#current_words_front').text(Number(current_words_front) + 22);
            $('#myvars').attr('front2go', Number(max_words_front - $('#current_words_front').text()));

          } else if (prev_skyline == 'back_only') {
            $('#current_words_front').text(Number(current_words_front) + 22);
            $('#current_words_back').text(Number(current_words_back) - 22);
            $('#myvars').attr('front2go', Number(max_words_front - $('#current_words_front').text()));
            $('#myvars').attr('back2go', Number(max_words_back - $('#current_words_back').text()));

          } else if (prev_skyline == 'both_sides') {
            $('#current_words_back').text(Number(current_words_back) - 22);
            $('#myvars').attr('back2go', Number(max_words_back - $('#current_words_back').text()));
          }

          prev_skyline = 'front_only';

          //back only
        } else if (sel == '24') {

          if (prev_skyline == 'front_only') {
            $('#current_words_front').text(Number(current_words_front) - 22);
            $('#current_words_back').text(Number(current_words_back) + 22);
            $('#myvars').attr('front2go', Number(max_words_front - $('#current_words_front').text()));
            $('#myvars').attr('back2go', Number(max_words_back - $('#current_words_back').text()));

          } else if (prev_skyline == 'none') {
            $('#current_words_back').text(Number(current_words_back) + 22);
            $('#myvars').attr('back2go', Number(max_words_back - $('#current_words_back').text()));

          } else if (prev_skyline == 'both_sides') {
            $('#current_words_front').text(Number(current_words_front) - 22);
            $('#myvars').attr('front2go', Number(max_words_front - $('#current_words_front').text()));
          }
          prev_skyline = 'back_only';

          // both
        } else if (sel == '25') {

          if (prev_skyline == 'front_only') {
            $('#current_words_back').text(Number(current_words_back) + 22);
            $('#myvars').attr('back2go', Number(max_words_back - $('#current_words_back').text()));

          } else if (prev_skyline == 'back_only') {
            $('#current_words_front').text(Number(current_words_front) + 22);
            $('#myvars').attr('front2go', Number(max_words_front - $('#current_words_front').text()));

          } else if (prev_skyline == 'none') {
            $('#current_words_front').text(Number(current_words_front) + 22);
            $('#myvars').attr('front2go', Number(max_words_front - $('#current_words_front').text()));
            $('#current_words_back').text(Number(current_words_back) + 22);
            $('#myvars').attr('back2go', Number(max_words_back - $('#current_words_back').text()));

          }

          prev_skyline = 'both_sides';

        } else if (sel == '20') {

          if (prev_skyline == 'front_only') {
            $('#current_words_front').text(Number(current_words_front) - 22);
            $('#myvars').attr('front2go', Number(max_words_front - $('#current_words_front').text()));

          } else if (prev_skyline == 'back_only') {
            $('#current_words_back').text(Number(current_words_back) - 22);
            $('#myvars').attr('back2go', Number(max_words_back - $('#current_words_back').text()));

          } else if (prev_skyline == 'both_sides') {
            $('#current_words_front').text(Number(current_words_front) - 22);
            $('#myvars').attr('front2go', Number(max_words_front - $('#current_words_front').text()));
            $('#current_words_back').text(Number(current_words_back) - 22);
            $('#myvars').attr('back2go', Number(max_words_back - $('#current_words_back').text()));

          }

          if ($('.form-item-attributes-6 .form-textarea').val() == '') {
            $('#current_words_front').text(0);
            $('#myvars').attr('front2go', max_words_front);
          }

          if ($('.form-item-attributes-7 .form-textarea').val() == '') {
            $('#current_words_back').text(0);
            $('#myvars').attr('back2go', max_words_back);
          }
          prev_skyline = 'none';
        }


        // hide front skyline if not enought letters
        if (Number(max_words_front - $('#current_words_front').text() < 22)) {
          if (prev_skyline == 'front_only') {
            $('.attribute-10 select option:nth-child(2)').attr('disabled', 'disabled');
          } else if (prev_skyline == 'back_only') {
            $('.attribute-10 select option:nth-child(2),.attribute-10 select option:nth-child(4)').attr('disabled', 'disabled');
          } else if (prev_skyline == 'both_sides') {
            $('.attribute-10 select option:nth-child(2),.attribute-10 select option:nth-child(4)').removeAttr('disabled');
          }
        } else {
          $('.attribute-10 select option:nth-child(2)').removeAttr('disabled');
          if (Number(max_words_back - $('#current_words_back').text() >= 22)) {
            $('.attribute-10 select option:nth-child(4)').removeAttr('disabled');
          }

        }

        // hide back skyline if not enought letters
        if (Number(max_words_back - $('#current_words_back').text() < 22)) {
          if (prev_skyline == 'back_only') {
            $('.attribute-10 select option:nth-child(3)').attr('disabled', 'disabled');
          } else if (prev_skyline == 'back_only') {
            $('.attribute-10 select option:nth-child(3),.attribute-10 select option:nth-child(4)').attr('disabled', 'disabled');
          } else if (prev_skyline == 'both_sides') {
            $('.attribute-10 select option:nth-child(3),.attribute-10 select option:nth-child(4)').removeAttr('disabled');
          }
        } else {
          $('.attribute-10 select option:nth-child(3)').removeAttr('disabled');
          if (Number(max_words_front - $('#current_words_front').text() >= 22)) {
            $('.attribute-10 select option:nth-child(4)').removeAttr('disabled');
          }
        }
      }, 500);
    } // end if($('.attribute-10').length>0) {
  }
  update_skyline();

  // change engraving click //$(document).on('click', '.change', function () {
  $(document).on('click', '.change', function () {
    //$('.change').unbind('click').click(function(){
    number_of_fit = 0;
    console.log('.change click 1:', $(this).parent().next(), ' 2: ', $(this).parent())
    if ($(this).parent().next().hasClass('front_sketch')) {
      front_or_back = 'front';
    } else {
      front_or_back = 'back';
    }
// added 20.3.2025. for bug 1
  $('#myvars').attr('front2go', Number($('#myvars').attr('max_words_front') - $('#current_words_front').text()));
			$('#myvars').attr('back2go', Number($('#myvars').attr('max_words_back') - $('#current_words_back').text()));
    

    // make sure it opens the phrases and not the names or the fav as default

    $('body').addClass('phrase_block');
    $('body').removeClass('names_block');
    $('body').removeClass('fav_block');

    $('#phrases_letters_wrapper').slideUp(200);
    $('#phrases_family .view-psukim-phrases').slideDown(200);

    // set body class
    phrases_or_names = 'phrases';
    $('body').addClass(phrases_or_names + '_active');
    $('body').removeClass('back');
    $('body').removeClass('front');
    $('body').addClass(front_or_back);
    // close show symbols
    $('.show_symbols').removeClass('show_symbols');

    // load sketch
    console.log('load sketch:',$('.' + front_or_back + '_sketch'));
    console.log('.' + front_or_back + '_sketch');
    $('#phrases_top_sketch').html($('.' + front_or_back + '_sketch').html());

    // if ok2translate show english button
    if (ok2translate == 1) {
      $(this).parent().find('.english').show();
    }

    // count each phrase number of letters and if there's room, add 1 to number_of_fit
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    console.log('front_back_2go:',front_back_2go);
    $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
      //console.log('cmp: ', $(this).text(), ' <= ', front_back_2go);
      if (Number($(this).text()) <= front_back_2go) {
        number_of_fit++;
        $(this).parent().removeClass('inactive');
        //console.log($(this).text());
      } else {
        $(this).parent().addClass('inactive');
      }
    });

    console.log('front_back_2go: '+front_back_2go+ 'number_of_fit: ' +number_of_fit );

    // update number of phrases that fit
    $('#filter_fit .filter_count').text(number_of_fit);

    // update number of total phrases
    if ($('body').hasClass('phrase_block')) {
      $('#filter_all .filter_count').text($('#phrases_block_content .phrase_word_count').length);
    } else if ($('body').hasClass('names_block')) {
      $('#filter_all .filter_count').text($('#names_block_content .phrase_word_count').length);
    }else{
      $('#filter_all .filter_count').text($('#fav_block_content .phrase_word_count').length);
    }


    // remove family titles as well
    $('#' + phrases_or_names + '_block_content .phrase_family_wrapper').each(function () {
      $(this).hide();
      var show_counter = 0;
      $(this).find('li').each(function () {
        if ($(this).hasClass('inactive') || $(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
          //console.log('has inactive/selected')
        }else{
          show_counter++;
        }
      });
      if (show_counter > 0) {
        $(this).show();
      }
    });

    // << load loved phrases from local storage
    lovedPhrasesRender();
    

    // >>

    // update block height
    if (winWidth > winHeight) {
      $('#phrases_block_wrapper').css({'height': '472px'});
    }
    $('#phrases_block_wrapper').scrollTop(0);

    // show / hide block contents
    $('#phrases_block_content').show();
    $('#names_block_content,#fav_block_content').hide();

    $('#phrases_names h2,#phrases_loved h2').removeClass('active');
    $('#phrases_family h2').addClass('active');

    // remove all ('search_inactive');
    $('.phrase').removeClass('search_inactive');

    // restart scrollbar jquery
    if (winWidth>760) {
      $("#phrases_block_wrapper").mCustomScrollbar("destroy");
      $("#phrases_block_wrapper").mCustomScrollbar({
        callbacks:{
          whileScrolling:function(){
            whilescroll();

          }
        }
      });
    }


  }); // end $(document).on('click','.change',function(){

 
  
  ////// translate button
  //$('.english').click(function(){
  $(document).on('mouseover', '.english', function () {

    if (ok2translate == 1) {
      var lines = $(this).parent().find('textarea').val().split('\n');

      // check if first and second phrases appear in phrases overlay and if so, copy their english
      $('.phrase_clean').each(function () {
        if ($.trim($(this).text()) == $.trim(lines[0])) {
          translation1 = $(this).parent().find('.phrase_eng').text();
        }
        if ($.trim($(this).text()) == $.trim(lines[1])) {
          translation2 = $(this).parent().find('.phrase_eng').text();
        }
      }); // end each

      if (lines[1]) {
        $(this).parent().find('.translate').html(translation1 + '<br>' + translation2);
      } else {
        $(this).parent().find('.translate').html(translation1);
      }
      $(this).parent().find('.translate').addClass('active');
    }
  }); // end $(document).on('mouseover','.english',function(){

  $(document).on('mouseout', '.english', function () {
    $(this).parent().find('.translate').removeClass('active');
  }); // end $(document).on('mouseout','.english',function(){

   $('#phrases_block').on('click', '.add2loved a', function(e) {
    var elem = $(this);
   e.stopPropagation();
    console.log('clicked flag-phrase ',elem);
    if (elem.hasClass('flag-action')) {
      // add to loved
      elem.removeClass('flag-action');
      elem.addClass('unflag-action');
      var p = elem.parent().parent().parent();
      console.log('parent flag phrase: ',p);
      lovedPhrasesAdd(p.data('id'), p.find('.phrase_eng').html(), p.find('.phrase_heb').html(), p.find('.phrase_tag').html(), p.find('.phrase_clean').html(), p.find('.phrase_word_count').html())
      
      lovedPhrasesRender();
    } else {
      // remove from loved
      elem.addClass('flag-action');
      elem.removeClass('unflag-action');

      var p = elem.parent().parent().parent();
      console.log('parent unflag phrase: ',p);
      lovedPhrasesRemove(p.data('id'));
      lovedPhrasesRender();
    }
  });
  
  /// selecting a phrase
  //$(document).on('click', '.phrase_heb,.phrase_eng', function () {
  $('#phrases_block').on('click', '.phrase', function(){
    console.log('phrase click handler');
    if(ok2choose==1){

      //if (!$(this).hasClass('inactive')) {

      // embed chosen text inside chosen containers ** if that's the first chosen phrase
      if ($('.phrase_chosen1 .chosen_heb').text() == 'text') {
        //show "You may select additional Pasuk & Phrase" text
        $('#phrases_chosen_title').show();

        $('.phrase_chosen1 .chosen_heb').html($(this).find('.phrase_heb').html());
        $('.phrase_chosen1 .chosen_eng').html($(this).find('.phrase_eng').html());
        // update chosen letter count number
        $('#myvars').attr('chosen1_letter_count', $(this).find('.phrase_word_count').text());
        selected1_number_of_words = Number($(this).find('.phrase_word_count').text());
        // show text
        $('#phrases_chosen_wrapper,.phrase_chosen1').show();
        // set chosen1_index
        $(this).addClass('selected1');
        $('#phrases_block_wrapper').css({'height': '302px'});

      } else {
        //hide "You may select additional Pasuk & Phrase" text
        $('#phrases_chosen_title').hide();

        $('.phrase_chosen2 .chosen_heb').html($(this).find('.phrase_heb').html());
        $('.phrase_chosen2 .chosen_eng').html($(this).find('.phrase_eng').html());
        // show text
        $('.phrase_chosen2').show();
        // update chosen letter count number
        $('#myvars').attr('chosen2_letter_count', $(this).find('.phrase_word_count').text());
        selected2_number_of_words = Number($(this).find('.phrase_word_count').text());
        $(this).addClass('selected2');
        $('#phrases_block_wrapper').css({'height': '255px'});
        // once there are two chosen, make all phrases inactive
        $('.phrase').addClass('inactive');
        // disable adding another phrase
        ok2choose=0;

      }

      //console.log('front_or_back: '+front_or_back + '/ phrases_or_names: '+phrases_or_names + '/ number_of_fit: ' +number_of_fit);

      // update front2go back2go
      number_of_fit = 0;
      front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));

      // update vars and number in phrase word count
      front_back_2go = front_back_2go - Number($(this).find('.phrase_word_count').text());
      $('#myvars').attr(front_or_back + '2go', front_back_2go);



      // count each phrase number of letters and if there's room, add 1 to number_of_fit
      $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {

        //console.log('$(this).parent().text():' + $(this).parent().text() + 'front_back_2go: '+ front_back_2go);
        if ($(this).text() <= front_back_2go) {
          number_of_fit++;
          $(this).parent().removeClass('inactive');
        } else {
          $(this).parent().addClass('inactive');
        }
      });

      // update number of fitting phrases
      var number_of_selected_that_fit = $('#' + phrases_or_names + '_block_content li.selected1').length + $('#' + phrases_or_names + '_block_content li.selected2').length;
      //$('#filter_fit .filter_count').text(number_of_fit - number_of_selected_that_fit);
      $('#filter_fit .filter_count').text(number_of_fit);

      //console.log('number_of_selected_that_fit: '+number_of_selected_that_fit + 'number_of_fit: '+ number_of_fit + 'front_back_2go: ' + front_back_2go);

      if (Number($('#filter_fit .filter_count').text()) < 0) {
        $('#filter_fit .filter_count').text(0);
      }

      //} // end if(!$(this).hasClass('inactive')){

      // remove family titles as well
      $('#' + phrases_or_names + '_block_content .phrase_family_wrapper').each(function () {
        $(this).hide();
        var show_counter = 0;
        $(this).find('li').each(function () {
          if ($(this).hasClass('inactive') || $(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
            //console.log('has inactive/selected')
          }else{
            show_counter++;
          }
        });
        if (show_counter > 0) {
          $(this).show();
        }
      });
    }

    phrase_was_chosen = 1;

  }); // end phrase click

  
  //// closing phrases with X
  $(document).on('click', '#phrases_popup_x_wrapper', function () {
    //$('#phrases_popup_x_wrapper').unbind('click').click(function(){

    $('body').removeClass('phrases_active').removeClass('names_active').removeClass('fav_active');

    // hide chosen
    $('#phrases_chosen_wrapper').hide();
    // remove selected class
    $('.phrase').removeClass('selected1');
    $('.phrase').removeClass('selected2');
    ok2choose=1;
    $('.phrase_chosen1 .chosen_heb').text('text');
    $('.phrase_chosen2 .chosen_heb').text('text');
    $('.phrase_chosen2').hide();

    $('#phrase_search').val('');

   /* if($('body').hasClass('front')){
      if(selected1_number_of_words!=undefined){
        $('#myvars').attr('front2go', Number($('#myvars').attr('front2go'))+selected1_number_of_words);
        if(selected2_number_of_words!=undefined){
          //alert();
          $('#myvars').attr('front2go', Number($('#myvars').attr('front2go'))+selected2_number_of_words);
        }
      }
    }else{
      if(selected1_number_of_words!=undefined) {
        $('#myvars').attr('back2go', Number($('#myvars').attr('back2go')) + selected1_number_of_words);
        if (selected2_number_of_words != undefined) {
          $('#myvars').attr('back2go', Number($('#myvars').attr('back2go')) + selected2_number_of_words);
        }
      }
    }*/

    // reset block wrapper height
    $('#phrases_block_wrapper').css({'height': '472px'});

    //remove chosen
    //remove_chosen();


  });
  
  $(document).on('click', '#phrases_names h2', function () {
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    $('#phrases_family .view-psukim-phrases, #phrases_family_list .category-list').slideUp(200);
    $('#phrases_letters_wrapper').slideDown(200);
    $('#phrases_family h2,#phrases_loved h2').removeClass('active');
    $(this).addClass('active');

    $('#phrases_block_wrapper').scrollTop(0);

    $('body').removeClass('phrase_block');
    $('body').addClass('names_block');
    $('body').removeClass('fav_block');

    phrases_or_names = 'names';
    // reset search
    $('#phrase_search').val('');
    $('.phrase').each(function () {
      $(this).addClass('search_inactive');
      var search_val = $('#phrase_search').val().toLowerCase();
      var my_heb = $(this).find('.phrase_clean').text().toLowerCase();
      var my_eng = $(this).find('.phrase_eng').text().toLowerCase();
      if (my_heb.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      } else if (my_eng.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      }
    });
    // show / hide block contents
    $('#phrases_block_content,#fav_block_content').hide();
    fetchQuoteLetter(0).then(exyz => {
    $('#names_block_content').show();

    // count each phrase number of letters and if there's room, add 1 to number_of_fit
    number_of_fit = 0;
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
      if ($(this).text() <= front_back_2go) {
        number_of_fit++;
        $(this).parent().removeClass('inactive');
        //console.log($(this).parent().find('.phrase_clean').text());
      } else {
        $(this).parent().addClass('inactive');
      }
    });
console.log($('#names_block_content .phrase_word_count'));
    // update number of phrases that fit
    $('#filter_fit .filter_count').text(number_of_fit);

    // update number of total phrases
    $('#filter_all .filter_count').text($('#names_block_content .phrase_word_count').length);

    //remove chosen
    $('#myvars').attr('chosen1_letter_count','0');
    selected1_number_of_words = 0;
    $('#myvars').attr('chosen2_letter_count','0');
    selected2_number_of_words = 0;

    // restart scrollbar jquery
    if (winWidth > winHeight) {
      //$('#phrases_block_wrapper').perfectScrollbar('destroy');
      //$('#phrases_block_wrapper').perfectScrollbar();
      $("#phrases_block_wrapper").mCustomScrollbar("destroy");
      $("#phrases_block_wrapper").mCustomScrollbar({
        callbacks:{
          whileScrolling:function(){
            whilescroll();
          }
        }
      });
    }
    $('#phrases_title').text('Psukim For Names');
  });
  });
  
  // click on family name
  $(document).on('click', '#phrases_family h2', function () {
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    $('#phrases_letters_wrapper').slideUp(200);
    $('#phrases_family .view-psukim-phrases').slideDown(200);
    $('#phrases_names h2,#phrases_loved h2').removeClass('active');
    $(this).addClass('active');

    $('body').addClass('phrase_block');
    $('body').removeClass('names_block');
    $('body').removeClass('fav_block');

    $('#phrases_block_wrapper').scrollTop(0);


    phrases_or_names = 'phrases';
    // reset search
    $('#phrase_search').val('');
    $('.phrase').each(function () {
      $(this).addClass('search_inactive');
      var search_val = $('#phrase_search').val().toLowerCase();
      var my_heb = $(this).find('.phrase_clean').text().toLowerCase();
      var my_eng = $(this).find('.phrase_eng').text().toLowerCase();
      if (my_heb.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      } else if (my_eng.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      }
    });

    // count each phrase number of letters and if there's room, add 1 to number_of_fit
    number_of_fit = 0;
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
      if ($(this).text() <= front_back_2go) {
        number_of_fit++;
        $(this).parent().removeClass('inactive');
        //console.log($(this).parent().find('.phrase_clean').text());
      } else {
        $(this).parent().addClass('inactive');
      }
    });

    // update number of phrases that fit
    $('#filter_fit .filter_count').text(number_of_fit);

    // update number of total phrases
    $('#filter_all .filter_count').text($('#phrases_block_content .phrase_word_count').length);

    // show / hide block contents
    $('#phrases_block_content').show();
    $('#names_block_content,#fav_block_content').hide();
    // call function to remove chosen
    //remove chosen
    $('#myvars').attr('chosen1_letter_count','0');
    selected1_number_of_words = 0;
    $('#myvars').attr('chosen2_letter_count','0');
    selected2_number_of_words = 0;

    // remove family titles as well
    $('#' + phrases_or_names + '_block_content .phrase_family_wrapper').each(function () {
      $(this).hide();
      var show_counter = 0;
      $(this).find('li').each(function () {
        if ($(this).hasClass('inactive') || $(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
          //console.log('has inactive/selected')
        }else{
          show_counter++;
        }
      });
      if (show_counter > 0) {
        $(this).show();
      }
    });

    // restart scrollbar jquery
    if (winWidth > winHeight) {
      //$('#phrases_block_wrapper').perfectScrollbar('destroy');
      //$('#phrases_block_wrapper').perfectScrollbar();

      $("#phrases_block_wrapper").mCustomScrollbar("destroy");
      $("#phrases_block_wrapper").mCustomScrollbar({
        callbacks:{
          whileScrolling:function(){
            whilescroll();
          }
        }
      });
    }

    $('#phrases_title').text('Psukim & Phrases');

  });
  
  // switch blocks (loved, phrases and names)
  $(document).on('click', '#phrases_loved h2', function () {
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    $('#phrases_family .view-psukim-phrases, #phrases_family_list .category-list, #phrases_names #phrases_letters_wrapper').slideUp(200);
    $('#phrases_names h2,#phrases_family h2, #phrases_family_list h2').removeClass('active');
    $('body').removeClass('phrase_block');
    $('body').removeClass('names_block');
    $('body').addClass('fav_block');

    $('#phrases_block_wrapper').scrollTop(0);

    $(this).addClass('active');
    $('#fav_block_content').show();
    $('#names_block_content,#phrases_block_content').hide();
    phrases_or_names = 'fav';

    // reset search
    $('#phrase_search').val('');
    $('.phrase').each(function () {
      $(this).addClass('search_inactive');
      var search_val = $('#phrase_search').val().toLowerCase();
      var my_heb = $(this).find('.phrase_clean').text().toLowerCase();
      var my_eng = $(this).find('.phrase_eng').text().toLowerCase();
      if (my_heb.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      } else if (my_eng.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      }
    });

    // count each phrase number of letters and if there's room, add 1 to number_of_fit
    number_of_fit = 0;
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
      if ($(this).text() <= front_back_2go) {
        number_of_fit++;
        $(this).parent().removeClass('inactive');
        //console.log($(this).parent().find('.phrase_clean').text());
      } else {
        $(this).parent().addClass('inactive');
      }
    });

    // update number of phrases that fit
    $('#filter_fit .filter_count').text(number_of_fit);

    // update number of total phrases
    $('#filter_all .filter_count').text($('#fav_block_content .phrase_word_count').length);

    //remove chosen
    $('#myvars').attr('chosen1_letter_count','0');
    selected1_number_of_words = 0;
    $('#myvars').attr('chosen2_letter_count','0');
    selected2_number_of_words = 0;

    // restart scrollbar jquery
    if (winWidth > winHeight) {
      //$('#phrases_block_wrapper').perfectScrollbar('destroy');
      //$('#phrases_block_wrapper').perfectScrollbar();
      $("#phrases_block_wrapper").mCustomScrollbar("destroy");
      $("#phrases_block_wrapper").mCustomScrollbar({
        callbacks:{
          whileScrolling:function(){
            whilescroll();
          }
        }
      });
    }else{

      $('#phrases_left').removeClass('active');
      $('*').scrollTop(0);
    }

    $('#phrases_title').text('Loved');


  }); // end // $(document).on('click','#phrases_loved',function()

  
  $(document).on('click', '#phrases_family_list h2', function () {
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    $('#phrases_letters_wrapper').slideUp(200);
    $('#phrases_family_list .category-list').slideDown(200);
    $('#phrases_names h2,#phrases_loved h2').removeClass('active');
    $(this).addClass('active');
    $('body').addClass('phrase_block');
    $('body').removeClass('names_block');
    $('body').removeClass('fav_block');

    $('#phrases_block_wrapper').scrollTop(0);

    $('#phrases_block_content').show();
    $('#names_block_content,#fav_block_content').hide();
    phrases_or_names = 'phrases';

    // reset search
    $('#phrase_search').val('');
    $('.phrase').each(function () {
      $(this).addClass('search_inactive');
      var search_val = $('#phrase_search').val().toLowerCase();
      var my_heb = $(this).find('.phrase_clean').text().toLowerCase();
      var my_eng = $(this).find('.phrase_eng').text().toLowerCase();
      if (my_heb.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      } else if (my_eng.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      }
    });

    // count each phrase number of letters and if there's room, add 1 to number_of_fit
    number_of_fit = 0;
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
      if ($(this).text() <= front_back_2go) {
        number_of_fit++;
        $(this).parent().removeClass('inactive');
        //console.log($(this).parent().find('.phrase_clean').text());
      } else {
        $(this).parent().addClass('inactive');
      }
    });

    // update number of phrases that fit
    $('#filter_fit .filter_count').text(number_of_fit);

    // update number of total phrases
    $('#filter_all .filter_count').text($('#fav_block_content .phrase_word_count').length);

    //remove chosen
    $('#myvars').attr('chosen1_letter_count','0');
    selected1_number_of_words = 0;
    $('#myvars').attr('chosen2_letter_count','0');
    selected2_number_of_words = 0;

    // restart scrollbar jquery
    if (winWidth > winHeight) {
      //$('#phrases_block_wrapper').perfectScrollbar('destroy');
      //$('#phrases_block_wrapper').perfectScrollbar();
      $("#phrases_block_wrapper").mCustomScrollbar("destroy");
      $("#phrases_block_wrapper").mCustomScrollbar({
        callbacks:{
          whileScrolling:function(){
            whilescroll();
          }
        }
      });
    }else{
      //$('#phrases_left').removeClass('active');
      $('*').scrollTop(0);
    }

    $('#phrases_title').text('Psukim & Phrases');


  }); // end // $(document).on('click','#phrases_family_list',function()
  
  // mobile filters toggle
  $(document).on('click', '.mobile-filters-toggle, #phrases_logo', function () {
    if(winWidth < winHeight) {
        const element = $(this).closest("#phrases_content")[0].querySelector("#phrases_left");
        element.classList.toggle("active");
        $('*').scrollTop(0);
        console.log(element);
    }
  });

	// phrases family click
  $(document).on('click', '.phrase-family-b', function () {

    var winWidth = $('body').innerWidth();
    var winHeight = window.innerHeight;

    // get index of clicked button
    var my_index = $('.phrase-family-b').index($(this));

    // auto scroll according to phrase family wrapper offset top
    if(winWidth>winHeight) {
      var elem = $('.phrase_family_wrapper:nth-child(' + Number(my_index + 1) + ')').position().top;
      $('.mCSB_container').animate({top: -elem}, {duration: 500, queue: false});

    }else if(winWidth>768){
      var elem = $('.phrase_family_wrapper:nth-child(' + Number(my_index + 1) + ')').position().top;
      $('.mCSB_container').animate({top: -elem}, {duration: 500, queue: false});
    }else{
      //var elem = $('.phrase_family_wrapper:nth-child(' + Number(my_index + 1) + ')').offset().top-Number(winHeight+60);
      var elem = $('.phrase_family_wrapper:nth-child(' + Number(my_index + 1) + ')').position().top+280;
      $('#phrases_content').animate({scrollTop: elem}, {duration: 500, queue: false});
      $('#phrases_left').removeClass('active');
    }
    $('.phrase-family-b').removeClass('active');
    $(this).addClass('active');

  });

  // click on letter
  $(document).on('mousedown', '.letter_b', function () {
    // set active
    $('.letter_b').removeClass('active');
    $(this).addClass('active');
    // get index of clicked button
    var my_index = $('.letter_b').index($(this));
    // get value number of option in listbox according to clicked button
    var option_value = $('#edit-field-first-letter-tid option:nth-child(' + Number(my_index + 2) + ')').attr('value');
    // change listbox active option according to clicked value
    $('#edit-field-first-letter-tid').val(option_value).change();
    // fadeOut
    $('#phrases_block_wrapper').hide();
    
    // scroll up
    $('#phrases_block_wrapper').scrollTop(0);
fetchQuoteLetter(my_index).then(exyz => {
    $('#phrases_block_wrapper').show();

  // count each phrase number of letters and if there's room, add 1 to number_of_fit
    number_of_fit = 0;
    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
      if ($(this).text() <= front_back_2go) {
        number_of_fit++;
        $(this).parent().removeClass('inactive');
        //console.log($(this).parent().find('.phrase_clean').text());
      } else {
        $(this).parent().addClass('inactive');
      }
    });
console.log($('#names_block_content .phrase_word_count'));
    // update number of phrases that fit
    $('#filter_fit .filter_count').text(number_of_fit);

    // update number of total phrases
    $('#filter_all .filter_count').text($('#names_block_content .phrase_word_count').length);

    //remove chosen
    $('#myvars').attr('chosen1_letter_count','0');
    selected1_number_of_words = 0;
    $('#myvars').attr('chosen2_letter_count','0');
    selected2_number_of_words = 0;
  
    // on mobile, close sub menu
    if(winWidth<winHeight){
      $('#phrases_left').removeClass('active');
    }
  // update large_letter
  $('.large_letter').text($('.letter_b.active').text());
});
  });

  $(document).on('click', '.chosen_garbage', function () {

    front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
    number_of_fit = 0;

    // if there were 2 phrases and the first was selected to garbage
    if ($('.phrase_chosen2 .chosen_heb').text() != 'text' && $(this).parent().hasClass('phrase_chosen1')) {

      //show "You may select additional Pasuk & Phrase" text
      $('#phrases_chosen_title').show();
      // remove first
      $('.phrase_chosen1').remove();
      //clone second
      $('.phrase_chosen2').clone().appendTo($('#phrases_chosen_wrapper'));
      // change first to chosen1
      $('#phrases_chosen_wrapper .phrase_chosen2:nth-child(2)').removeClass('phrase_chosen2').addClass('phrase_chosen1');
      // embed text (for testing in second)
      $('.phrase_chosen2 .chosen_heb').text('text');
      // hide text
      $('.phrase_chosen2').hide();

      // update front and back 2 go
      $('#myvars').attr(front_or_back + '2go', front_back_2go + Number($('#myvars').attr('chosen1_letter_count')));
      front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));

      // count each phrase number of letters and if there's room, add 1 to number_of_fit
      $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
        if ($(this).text() <= front_back_2go) {
          number_of_fit++;
          $(this).parent().removeClass('inactive');
        } else {
          $(this).parent().addClass('inactive');
        }
      });

      // remove selected class
      var phrase_child = Number($('#myvars').attr('chosen1_index')) + 1;
      $('.phrase:nth-child(' + phrase_child + ')').removeClass('selected');

      $('#myvars').attr('chosen1_index', $('#myvars').attr('chosen2_index'));

      // update block height
      $('#phrases_block_wrapper').css({'height': '302px'});

      // enable adding phrase
      ok2choose=1;

      // if there is only one chosen and selected to garbage
    } else if ($(this).parent().hasClass('phrase_chosen1')) {
      // hide text
      $('#phrases_chosen_wrapper,.phrase_chosen1').hide();
      // update front and back 2 go
      $('#myvars').attr(front_or_back + '2go', front_back_2go + Number($('#myvars').attr('chosen1_letter_count')));
      front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));

      // count each phrase number of letters and if there's room, add 1 to number_of_fit
      $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
        if ($(this).text() <= front_back_2go) {
          number_of_fit++;
          $(this).parent().removeClass('inactive');
        } else {
          $(this).parent().addClass('inactive');
        }
      });

      // embed text (for testing in second)
      $('.phrase_chosen1 .chosen_heb,.phrase_chosen2 .chosen_heb').text('text');

      // remove selected class
      $('.phrase').removeClass('selected1');

      // update block height
      $('#phrases_block_wrapper').css({'height': '472px'});

      // enable adding phrase
      ok2choose=1;

      // if there are two and second was garbaged
    } else if ($(this).parent().hasClass('phrase_chosen2')) {

      //show "You may select additional Pasuk & Phrase" text
      $('#phrases_chosen_title').show();

      // hide text
      $('.phrase_chosen2').hide();
      // embed text (for testing in second)
      $('.phrase_chosen2 .chosen_heb').text('text');
      // update front and back 2 go

      // remove selected class
      $('.phrase').removeClass('selected2');

      $('#myvars').attr(front_or_back + '2go', front_back_2go + Number($('#myvars').attr('chosen2_letter_count')));
      front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));

      // count each phrase number of letters and if there's room, add 1 to number_of_fit

      $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
        if ($(this).text() <= front_back_2go) {
          number_of_fit++;
          $(this).parent().removeClass('inactive');
        } else {
          $(this).parent().addClass('inactive');
        }
      });

      // enable adding phrase
      ok2choose=1;


      // update block height
      $('#phrases_block_wrapper').css({'height': '302px'});
    }


    // update number of fitting phrases
    if ($('body').hasClass('phrase_block')) {
      var number_of_selected_that_fit = $('#phrases_block_content li.selected1').length + $('#phrases_block_content li.selected2').length;
      $('#filter_fit .filter_count').text(number_of_fit - number_of_selected_that_fit);
    } else {
      var number_of_selected_that_fit = $('#names_block_content li.selected1').length + $('#names_block_content li.selected2').length;
      $('#filter_fit .filter_count').text(number_of_fit - number_of_selected_that_fit);
    }
    // make sure fit number is positive
    if (Number($('#filter_fit .filter_count').text()) < 0) {
      $('#filter_fit .filter_count').text(0);
    }

    // remove family titles as well
    $('#' + phrases_or_names + '_block_content .phrase_family_wrapper').each(function () {
      $(this).hide();
      var show_counter = 0;
      $(this).find('li').each(function () {
        if ($(this).hasClass('inactive') || $(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
           console.log('has inactive/selected')
        }else{
          show_counter++;
        }
      });
      if (show_counter > 0) {
        $(this).show();
      }
    });

  }); // end clicked garbage


  /// search phrase
  $(document).on('keyup', '#phrase_search', function () {
    if (document.body.classList.contains('node-type-hadayasbook')) return; // Book has one scoped input handler.
    //console.log(phrases_or_names);

    $('#' + phrases_or_names + '_block_content .phrase').each(function () {
      $(this).addClass('search_inactive');
      var search_val = $('#phrase_search').val().toLowerCase();
      var my_heb = $(this).find('.phrase_clean').text().toLowerCase();
      var my_eng = $(this).find('.phrase_eng').text().toLowerCase();

      if (my_heb.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      }
      if (my_eng.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      }
    });

    var show_counter = 0;
    // remove family titles as well
    $('#' + phrases_or_names + '_block_content .phrase_family_wrapper').each(function () {
      $(this).hide();
      show_counter = 0;
      $(this).find('li').each(function () {
        //if ($(this).hasClass('inactive') || $(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
        if ($(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
          // console.log('has inactive/selected')
        }else{
          show_counter++;
        }
      });
      if (show_counter > 0) {
        $(this).show();
      }
    });

    // update number of phrases that fit
    $('#filter_fit .filter_count').text($('#' + phrases_or_names + '_block_content .phrase:not(.search_inactive,.inactive,.selected)').length);


  });

  ///////////////// clicking on chosen_done

  //$('.chosen_done').click(function(){
  $(document).on('click', '.chosen_done', function () {
    //$('.chosen_done').unbind('click').click(function(){

    // enable ok2choose
    ok2choose=1;

    // hide phrases overlay
    $('body').removeClass('phrases_active');

    //empty search input
    $('#phrase_search').val('');
    $('#' + phrases_or_names + '_block_content .phrase').each(function () {
      $(this).removeClass('search_inactive');
    });

    var selected_text1 = $.trim($('.selected1 .phrase_clean').text());
    var selected_text2 = $.trim($('.selected2 .phrase_clean').text());

    if ($('body').hasClass('front')) {
      $('.front_tbox .change').addClass('book_close');

      // if there is only one sentence
      if ($('.phrase_chosen2 .chosen_heb').text() == 'text') {

        // if textarea is empty
        if ($('.front_tbox textarea').val() == '') {
          $('.front_tbox textarea').val(selected_text1);
        } else {
          $('.front_tbox textarea').val($('.front_tbox textarea').val() + ' \n' + selected_text1);
        }
        /////////////////// if there are two sentences
      } else {
        // if textarea is empty
        if ($('.front_tbox textarea').val() == '') {
          $('.front_tbox textarea').val(selected_text1 + '\n' + selected_text2);
        } else {
          $('.front_tbox textarea').val($('.front_tbox textarea').val() + ' \n' + selected_text1 + '\n' + selected_text2);
        }

        $('.phrase_chosen2').hide();
        $('.phrase_chosen2 .chosen_heb').text('text');
      }
      setUserInputTextarea('front', $('.front_tbox textarea').val());

      // if back
    } else {
      $('.back_tbox .change').addClass('book_close');
      // if there is only one sentence
      if ($('.phrase_chosen2 .chosen_heb').text() == 'text') {
        // if textarea is empty
        if ($('.back_tbox textarea').val() == '') {
          $('.back_tbox textarea').val(selected_text1);
        } else {
          $('.back_tbox textarea').val($('.back_tbox textarea').val() + ' \n' + selected_text1);
        }
        /////////////////// if there are two sentences
      } else {
        // if textarea is empty
        if ($('.back_tbox textarea').val() == '') {
          $('.back_tbox textarea').val(selected_text1 + '\n' + selected_text2);
        } else {
          $('.back_tbox textarea').val($('.back_tbox textarea').val() + ' \n' + selected_text1 + '\n' + selected_text2);
        }

        $('.phrase_chosen2').hide();
        $('.phrase_chosen2 .chosen_heb').text('text');

      }
      setUserInputTextarea('back', $('.back_tbox textarea').val());
    } // end front or back


    // update current words number on load closing the overlay/*
    if($('body').hasClass('front')){
      if($('.front_tbox textarea').length > 0) {
        words = $('.front_tbox textarea').val().length - 1;
        // if there are two phrases selected, we need to count the new line as a gap
        if(selected_text2!=''){
          //alert();
          words = words +($(this).val().length);
        }else{
          words = words +($(this).val().length);
        }

      }
      if (words == 0) {
        $('#current_words_front').text(0);
      } else {
        $('#current_words_front').text(Number(words + 1));
      }

      max_words_front = $('#myvars').attr('max_words_front');

      if (max_words_front <= words) {
        $('.front_tbox .word_counter_wrapper').addClass('red_alert');
      }else{
        $('.front_tbox .word_counter_wrapper').removeClass('red_alert');
      }

    }

    if($('body').hasClass('back')) {
      if ($('.back_tbox textarea').length > 0) {
        words = $('.back_tbox textarea').val().length-1;
        // if there are two phrases selected, we need to count the new line as a gap
        if(selected_text2!=''){
          //alert();
          words = words +($(this).val().length);
        }else{
          words = words +($(this).val().length);
        }
      }
      if (words == 0) {
        $('#current_words_back').text(0);
      } else {
        $('#current_words_back').text(Number(words + 1));
      }
      max_words_back = $('#myvars').attr('max_words_back');
      if (max_words_back <= words) {
        $('.back_tbox .word_counter_wrapper').addClass('red_alert');
      }else{
        $('.back_tbox .word_counter_wrapper').removeClass('red_alert');
      }
    }

    // embed text (for testing in second)
    $('.phrase_chosen1 .chosen_heb,.phrase_chosen2 .chosen_heb').text('text');
    // hide chosen
    $('#phrases_chosen_wrapper').hide();
    // remove selected class
    $('.phrase').removeClass('selected1');
    $('.phrase').removeClass('selected2');

    // remove family titles as well
    $('#' + phrases_or_names + '_block_content .phrase_family_wrapper').each(function () {
      //$(this).hide();
      var show_counter = 0;
      $(this).find('li').each(function () {
        if ($(this).hasClass('inactive') || $(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
          console.log('has inactive/selected')
        }else{
          show_counter++;
        }
      });
      if (show_counter > 0) {
        $(this).show();
      }
    });

    // reset block wrapper height
    $('#phrases_block_wrapper').css({'height': '472px'});

    setTimeout(function () {

      // if skyline was added, add 5 words to counter
      sel = $('.attribute-10 select option:selected').val();

      //max_words_front = $('#myvars').attr('max_words_front');
      //max_words_back = $('#myvars').attr('max_words_back');

      //front only
      if (sel == '21') {
        if($('body').hasClass('front')){
          $('#current_words_front').text(Number($('#current_words_front').text()) + 22);
          //sel = $('.attribute-10 select').val('20');
        }else{

        }

        //back only
      } else if (sel == '24') {
        if($('body').hasClass('back')){
          $('#current_words_back').text(Number($('#current_words_back').text()) + 22);
          //sel = $('.attribute-10 select').val('20');
        }else{

        }
        // both
      } else if (sel == '25') {
        if($('body').hasClass('front')){
          $('#current_words_front').text(Number($('#current_words_front').text()) + 22);
        }else{
          $('#current_words_back').text(Number($('#current_words_back').text()) + 22);
        }

      }

      max_words_front = $('#myvars').attr('max_words_front');
      max_words_back = $('#myvars').attr('max_words_back');

      // hide front skyline if not enought letters
      if (Number(max_words_front - $('#current_words_front').text()) < 22) {
        $('.attribute-10 select option:nth-child(2),.attribute-10 select option:nth-child(4)').attr('disabled','disabled');
        if (Number(max_words_back - $('#current_words_back').text()) >= 22) {
          $('.attribute-10 select option:nth-child(3)').removeAttr('disabled');
        }
      }

      // hide back skyline if not enought letters
      if (Number(max_words_back - $('#current_words_back').text()) < 22) {

        $('.attribute-10 select option:nth-child(3),.attribute-10 select option:nth-child(4)').attr('disabled','disabled');
        if (Number(max_words_front - $('#current_words_front').text()) >= 22) {
          $('.attribute-10 select option:nth-child(2)').removeAttr('disabled');
        }
      }



    }, 500);

    /********************************/



  }); // end clicking done

  /// search phrase
  $(document).on('keyup', '#phrase_search', function () {
    if (document.body.classList.contains('node-type-hadayasbook')) return; // Book has one scoped input handler.
    //console.log(phrases_or_names);

    $('#' + phrases_or_names + '_block_content .phrase').each(function () {
      $(this).addClass('search_inactive');
      var search_val = $('#phrase_search').val().toLowerCase();
      var my_heb = $(this).find('.phrase_clean').text().toLowerCase();
      var my_eng = $(this).find('.phrase_eng').text().toLowerCase();

      if (my_heb.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      }
      if (my_eng.indexOf(search_val) >= 0) {
        $(this).removeClass('search_inactive');
      }
    });

    var show_counter = 0;
    // remove family titles as well
    $('#' + phrases_or_names + '_block_content .phrase_family_wrapper').each(function () {
      $(this).hide();
      show_counter = 0;
      $(this).find('li').each(function () {
        //if ($(this).hasClass('inactive') || $(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
        if ($(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
          // console.log('has inactive/selected')
        }else{
          show_counter++;
        }
      });
      if (show_counter > 0) {
        $(this).show();
      }
    });

    // update number of phrases that fit
    $('#filter_fit .filter_count').text($('#' + phrases_or_names + '_block_content .phrase:not(.search_inactive,.inactive,.selected)').length);


  });
  
  ///////// function remove_chosen()

  function remove_chosen() {

    if(phrase_was_chosen==1) {

      if ($('body').hasClass('front')) {
        front_or_back = 'front';
      } else {
        front_or_back = 'back';
      }

      front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));
      // remove selected class
      $('.phrase').removeClass('selected1');
      $('.phrase').removeClass('selected2');
      // hide chosen phrases
      $('#phrases_chosen_wrapper,.phrase_chosen1,.phrase_chosen2').hide();

      // embed text (for testing in second) - reset text content
      $('.phrase_chosen1 .chosen_heb,.phrase_chosen2 .chosen_heb').text('text');

      // update front and back 2 go
      $('#myvars').attr(front_or_back + '2go', front_back_2go + Number($('#myvars').attr('chosen1_letter_count')));
      front_back_2go = Number($('#myvars').attr(front_or_back + '2go'));

      number_of_fit = 0;
      // count each phrase number of letters and if there's room, add 1 to number_of_fit
      $('#' + phrases_or_names + '_block_content .phrase_word_count').each(function () {
        if ($(this).text() <= front_back_2go) {
          number_of_fit++;
          $(this).parent().removeClass('inactive');
        } else {
          $(this).parent().addClass('inactive');
        }
      });
      // update block height
      $('#phrases_block_wrapper').css({'height': '472px'});
      // update number of fitting phrases
      if ($('body').hasClass('phrase_block')) {
        number_of_selected_that_fit = $('#phrases_block_content li.selected1').length + $('#phrases_block_content li.selected2').length;
        $('#filter_fit .filter_count').text(number_of_fit - number_of_selected_that_fit);
      } else if ($('body').hasClass('names_block')) {
        number_of_selected_that_fit = $('#names_block_content li.selected1').length + $('#names_block_content li.selected2').length;
        $('#filter_fit .filter_count').text(number_of_fit - number_of_selected_that_fit);
      } else {
        number_of_selected_that_fit = $('#fav_block_content li.selected1').length + $('#fav_block_content li.selected2').length;
        $('#filter_fit .filter_count').text(number_of_fit - number_of_selected_that_fit);
      }

      //alert(number_of_selected_that_fit);
      // make sure fit number is positive
      if (Number($('#filter_fit .filter_count').text()) < 0) {
        $('#filter_fit .filter_count').text(0);
      }
      // update all phrases count
      $('#filter_all .filter_count').text($('#' + phrases_or_names + '_block_content li').length);

      // restart scrollbar jquery
      if (winWidth > winHeight) {
        //$('#phrases_block_wrapper').perfectScrollbar('destroy');
        //$('#phrases_block_wrapper').perfectScrollbar();
        $("#phrases_block_wrapper").mCustomScrollbar("destroy");
        $("#phrases_block_wrapper").mCustomScrollbar({
          callbacks:{
            whileScrolling:function(){
              whilescroll();
            }
          }
        });

      }

      phrase_was_chosen = 0;

    } // end if phrase was chosen



  } ////////////// end function remove_chosen()


/*
  // update large_letter
  $('.large_letter').text($('.letter_b.active').text());
*/
  // remove family titles as well (if that's phrase
  if($('body').hasClass('phrases_active')) {
    $('#phrases_block_content .phrase_family_wrapper').each(function () {
      //$(this).hide();
      var show_counter = 0;
      $(this).find('li').each(function () {
        if ($(this).hasClass('inactive') || $(this).hasClass('search_inactive') || $(this).hasClass('selected1') || $(this).hasClass('selected2') || $(this).hasClass('selected')) {
          console.log('has inactive/selected')
        } else {
          show_counter++;
        }
      });
      if (show_counter > 0) {
        $(this).show();
      }
    });
  }
  
  /////////// make sure numbers are being updated on names
  number_of_fit = 0;
  // update number of fitting phrases
  if ($('body').hasClass('phrase_block')) {
    var number_of_selected_that_fit = $('#phrases_block_content li.selected1').length + $('#phrases_block_content li.selected2').length;
    $('#filter_fit .filter_count').text(number_of_fit - number_of_selected_that_fit);
    $('#filter_all .filter_count').text($('#phrases_block_content .view-content li').length);
    if (number_of_selected_that_fit == 0) {
      $('#filter_fit .filter_count').text($('#phrases_block_content .view-content li').length);
    }
  } else if ($('body').hasClass('names_block')) {/*
				var number_of_selected_that_fit = $('#names_block_content li.selected1').length + $('#names_block_content li.selected2').length;
				//$('#filter_fit .filter_count').text(number_of_fit - number_of_selected_that_fit);
				$('#filter_all .filter_count').text($('#names_block_content .view-content li').length);
				if (number_of_selected_that_fit == 0) {
				//	$('#filter_fit .filter_count').text($('#names_block_content .view-content li').length);

				}*/
  } else {
    var number_of_selected_that_fit = $('#fav_block_content li.selected1').length + $('#fav_block_content li.selected2').length;
    $('#filter_fit .filter_count').text(number_of_fit - number_of_selected_that_fit);
    $('#filter_all .filter_count').text($('#fav_block_content .view-content li').length);
  }


  //update names all number
  //$('#filter_all .filter_count').text($('#names_block_content .view-content li').length);
  // make sure fit number is positive
  if (Number($('#filter_fit .filter_count').text()) < 0) {
    //$('#filter_fit .filter_count').text(0);
  }

    // update number of phrases that fit

	// update search placeholder
	$('#search input').attr('placeholder','Search');

	$('#search input').keyup(function(){
		var chars = $(this).val().length;
		var mywidth = $(this).width();
		var myleft = $(this).css('margin-left');
		myleft = parseInt(myleft, 10);
		//console.log(myleft);
		if(chars >12){
			$(this).width(mywidth+7);
			$(this).css({'margin-left':myleft-7})
		}
	});
  			/// clicking on .phrases_filter
			//$('.phrases_filter').click(function(){
			$(document).on('click', '.phrases_filter', function () {
				$('.phrases_filter').removeClass('active');
				$(this).addClass('active');

				if ($(this).attr('id') == "filter_all") {
					$('body').addClass('show_all');
				} else {
					$('body').removeClass('show_all');
				}
			});

			// change engraving click //$(document).on('click', '.change', function () {
          
			// clicking on play
			$(document).on('click', '.vid', function(e) {
				e.stopPropagation();
				$('#overlay,.iframe_wrapper').fadeIn(300);
				var myurl = $(this).find('>div').text();
				var myurl1 = atob(myurl);
				$('.iframe_wrapper iframe').remove();
				$('.iframe_wrapper').append(myurl1);
			})

			$(document).on('click', '.iframe_wrapper .x_wrapper', function () {
				$('#overlay ,.iframe_wrapper').fadeOut(300);
				$('.iframe_wrapper iframe').remove();
			});

});